/**
 * Parse TipTap-style ++underline++ markers into <u> nodes for react-markdown.
 * Standard Markdown has no underline; TipTap serializes the underline mark as ++text++.
 */
const UNDERLINE_RE = /\+\+((?:(?!\+\+)[^\n])+)\+\+/g;

function splitTextNode(node) {
  const value = node.value || "";
  UNDERLINE_RE.lastIndex = 0;
  if (!UNDERLINE_RE.test(value)) return [node];
  UNDERLINE_RE.lastIndex = 0;

  const parts = [];
  let lastIndex = 0;
  let match;
  while ((match = UNDERLINE_RE.exec(value)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: "text", value: value.slice(lastIndex, match.index) });
    }
    parts.push({
      type: "underline",
      data: { hName: "u" },
      children: [{ type: "text", value: match[1] }],
    });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < value.length) {
    parts.push({ type: "text", value: value.slice(lastIndex) });
  }
  return parts.length ? parts : [node];
}

function transformNodes(nodes) {
  if (!Array.isArray(nodes)) return;
  for (let i = 0; i < nodes.length; i += 1) {
    const node = nodes[i];
    if (!node) continue;
    if (node.type === "text") {
      const replacement = splitTextNode(node);
      if (replacement.length !== 1 || replacement[0] !== node) {
        nodes.splice(i, 1, ...replacement);
        i += replacement.length - 1;
      }
      continue;
    }
    if (Array.isArray(node.children)) {
      transformNodes(node.children);
    }
  }
}

export function remarkUnderline() {
  return (tree) => {
    if (tree?.children) transformNodes(tree.children);
  };
}
